// extracted by mini-css-extract-plugin
export default {"bowtie-meatball-menu-content":"bowtie-meatball-menu__bowtie-meatball-menu-content--bTt7G","bowtieMeatballMenuContent":"bowtie-meatball-menu__bowtie-meatball-menu-content--bTt7G"};